import VueApexCharts from "vue-apexcharts";
import datePicker from "@/views/reportsellcourse/graphreport/dialog/datepicker.vue";

import downloadexcel from "vue-json-excel";
import {
    getGraphSellReport,
    getExcel,
} from "@/service/reportsellcourse/reportsellcourse";

export default {
    props: {
        dataGraph: {
            type: Object,
        },
    },

    components: {
        downloadexcel,
        datePicker,
        apexchart: VueApexCharts,
    },

    data() {
        return {
            loaddata: false,
            datepicker: false,
            dates: [],
            chartOptions: {
                chart: {


                    type: "area",
                    stacked: true,
                    height: 500
                },
                dataLabels: {
                    enabled: false
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '40px',
                    },
                },

                xaxis: {
                    type: 'category'
                },

                fill: {
                    opacity: 1
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val + " คน"
                        }
                    }
                }
            },
            fileExcelName: "reportDaily.xls",
            json_fields: {
                วันที่: "startDay",
                การซื้อคอร์ส: "countPrice",
            },
            series: [],
            menu: false,
            dateParams: [],
            sumPrices: 0,
            // dataGraph: {},
        }
    },
    mounted() {
        this.initialize()
    },
    watch: {
        dataGraph(value) {
            this.dataGraph = value
            this.initialize()

        },
    },
    methods: {
        async initialize() {
            let result = this.dataGraph.arrayResult ? this.dataGraph.arrayResult : []
            console.log(result)
            let arrayGraph = []
            let sumPrice = 0
            await result.forEach((Item, index) => {
                arrayGraph.push({ y: Item.countPrice, x: Item.startDay })
                sumPrice = sumPrice + Item.countPrice
            })
            this.series = [{
                name: 'จำนวนเงิน',
                data: arrayGraph
            }]
            this.sumPrices = sumPrice
        },
        async createGraphSell(dateParams) {
            this.loaddata = true
            let result = await getGraphSellReport(dateParams)
            let arrayGraph = []
            await result.arrayResult.forEach((Item, index) => {
                arrayGraph.push({ y: Item.countPrice, x: Item.startDay })
            })
            this.series = [{
                name: 'จำนวนเงิน',
                data: arrayGraph
            }]
            this.loaddata = arrayGraph ? false : true
        },
        async okDialogdatepicker() {
            console.log("ok")
            console.log(this.dateParams.starttime + " " + this.dateParams.endtime + "<< ok picker")
            await this.createGraphSell(this.dateParams)
        },
        sendStartTime(value) {
            this.dateParams = value
        },
        async exportReport() {
            console.log("exportReport")
            this.loaddata = true
            let dataExal = await getExcel(this.dataParams);

            this.loaddata = dataExal.arrayResult ? false : true
            return dataExal.arrayResult
        },
    }
}